import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCustomerActivePolicy,
  getSingleCustomer,
  resetCustomerStatus,
} from "../../../redux/slice/customer/customerSlice";
import { BounceLoader } from "react-spinners";
import IndividualCustomerProfile from "./IndividualCustomerProfile";
import CorporateCustomerProfile from "./CorporateCustomerProfile";

const CustomerProfile = () => {
  // const { state } = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);
  const {
    single_customer,
    isLoading,
    isUpdateSuccess,
    customer_active_policy,
  } = useSelector((state) => state?.customer);

  useEffect(() => {
    dispatch(
      getCustomerActivePolicy(single_customer?.basic_information?.customer_id)
    );
  }, [dispatch, single_customer?.basic_information?.customer_id]);

  useEffect(() => {
    const payload = {
      id: id,
      office_id: user?.user?.office_id,
    };
    dispatch(getSingleCustomer(payload));

    if (isUpdateSuccess) {
      dispatch(getSingleCustomer(payload));
      dispatch(resetCustomerStatus());
    }
  }, [dispatch, isUpdateSuccess, id]);

  useEffect(() => {
    if (
      !user?.user_permissions?.some(
        (permission) => permission.name === "customer module"
      ) ||
      !user?.user_permissions?.some(
        (permission) => permission.name === "view customer details"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user?.user_permissions]);

  return (
    <>
      {isLoading ? (
        <div className='d-flex mt-lg-5 justify-content-center align-content-center py-3'>
          <BounceLoader color='#2E3192' size={"70px"} />
        </div>
      ) : (
        <div>
          {single_customer?.basic_information?.customer_type ===
          "Individual" ? (
            <IndividualCustomerProfile
              single_customer={single_customer}
              active_policy={customer_active_policy}
            />
          ) : (
            <CorporateCustomerProfile single_customer={single_customer} />
          )}
        </div>
      )}
    </>
  );
};

export default CustomerProfile;
